export default __webpack_public_path__ + "static/media/plus-white.16ef2a4d.svg";